
export function getAssetPath(path) {
    return `https://assets.motionarray.com/${path}`;
}

export function getImagesPath(path) {
    return `https://content.motionarray.com/images/${path}`;
}

export function getPreviewsPath(path) {
    return `https://content.motionarray.com/${path}`;
}